import { ff } from '@atlassian/jira-feature-flagging';

export const isRemoveParentLinkFromIssueViewEnabled = () =>
	ff('remove-parent-link-from-issue-view_4t7dy', false);

export const isHideEpicLinkFromIssueViewForEpicRenamingBetaEnabled = () =>
	ff('hide-epic-link-from-issue-view-for-epic-renaming-beta_r1g77', false);

export const isJsmTimelineEnabled = (): boolean => ff('jsm-timelines-phase-2_70gja', false);
